// export const API_URL=process.env.RAZZLE_APP_API_URL;
export const API_URL=process.env.REACT_APP_API_URL;
